import React from 'react';
import { LyraSleepListicle } from './pages/LyraSleepListicle';
export function App() {
  return <LyraSleepListicle data-id="element-0" />;
}